{
  "eyebrow": "Maak je account aan",
  "title": "Enkele gegevens over je bedrijf.",
  "sub": "Jij wordt de hoofdbeheerder. Je kan later meer beheerders uitnodigen.",
  "company": "Bedrijf",
  "companyName": "Bedrijfsnaam",
  "companyVat": "Btw-nummer",
  "companyVatBssHint": "Vereist voor de aangiften bij de Belgische sociale zekerheid (DIMONA).",
  "companyCountry": "Land",
  "admin": "Hoofdbeheerder",
  "adminFirst": "Voornaam",
  "adminLast": "Achternaam",
  "adminEmail": "Werk e-mail",
  "adminPhone": "Telefoon",
  "adminPw": "Wachtwoord",
  "adminPwHint": "Minstens 10 tekens, één cijfer.",
  "adminPwShow": "Wachtwoord tonen",
  "adminPwHide": "Wachtwoord verbergen",
  "terms": {
    "pre": "Ik ga akkoord met de",
    "t": "Algemene voorwaarden",
    "and": "en het",
    "p": "Privacybeleid"
  },
  "cta": "Account aanmaken & doorgaan",
  "errors": {
    "required": "Verplicht",
    "tooShort": "Te kort",
    "invalidEmail": "Geef een geldig e-mailadres",
    "invalidVat": "Geef een geldig btw-nummer",
    "invalidBelgianVat": "Geef een geldig Belgisch btw-nummer (bijv. BE0123456789).",
    "invalidPhone": "Geef een geldig telefoonnummer",
    "passwordWeak": "Minstens 10 tekens en één cijfer",
    "termsRequired": "Aanvaard de voorwaarden",
    "emailExists": "Dit e-mailadres is al in gebruik",
    "vatRequiredForBss": "Btw-nummer is vereist voor Belgische sociale zekerheid",
    "network": "Netwerk- of serverfout. Probeer opnieuw.",
    "throttled": "Te veel pogingen. Probeer het over {{minutes}} min. opnieuw."
  },
  "verify": {
    "awaitingTitle": "Bekijk je inbox",
    "awaitingSub": "We hebben een verificatielink naar {{email}} gestuurd. Klik erop om je account te activeren en je gratis proefperiode te starten.",
    "awaitingSubNoEmail": "We hebben je een verificatielink gestuurd. Klik erop om je account te activeren en je gratis proefperiode te starten.",
    "resend": "E-mail opnieuw verzenden",
    "resendCooldown": "Opnieuw verzenden over {{seconds}}s",
    "verifyingTitle": "Bezig met verifiëren…",
    "successTitle": "Je gratis proefperiode van 30 dagen is gestart!",
    "successSub": "Geen creditcard nodig. Meld je aan bij je dashboard om Done-it te gaan gebruiken.",
    "errorTitle": "We konden de link niet verifiëren",
    "errorSub": "De link is mogelijk verlopen. Begin opnieuw vanaf je accountgegevens.",
    "errorCta": "Terug naar account",
    "interstitial": "E-mailverificatie",
    "subscribedTitle": "Je account is klaar",
    "subscribedSub": "De betaling is al voltooid. Meld je aan op je dashboard om met Done-it te beginnen.",
    "subscribedCta": "Aanmelden op dashboard",
    "successCta": "Dashboard openen",
    "successNote": "Je ontvangt tijdens je proefperiode een paar handige e-mails en tegen het einde een link om je te abonneren.",
    "awaitingSubFree": "We hebben een verificatielink naar {{email}} gestuurd. Klik erop om je gratis account te activeren — Time Zero is voor altijd gratis, geen creditcard.",
    "awaitingSubFreeNoEmail": "We hebben je een verificatielink gestuurd. Klik erop om je gratis account te activeren — Time Zero is voor altijd gratis, geen creditcard.",
    "successTitleFree": "Je gratis account is klaar!",
    "successNoteFree": "Time Zero is voor altijd gratis binnen de limieten. Upgrade wanneer je wilt voor onbeperkt gebruik."
  }
}
